import React from 'react';

export default function BottomArea() {
    return (
        <footer>
            <img className="ecfLogo" src="/Images/Site/ECFLogo.png" alt="A Solution by ECF" title="A Solution by ECF" />
            <span className="ecfText">A Solution by ECF (Ertebatat Control Faragostar)</span>
        </footer>
    )
}
